$(function () {
  const items = this.querySelectorAll('.prose .collapse-item');
  items.forEach((item) => {
    const header = item.querySelector('.collapse-header');
    const content = item.querySelector('.collapse-content');
    const inner = content.querySelector('.collapse-inner');

    // 设置初始高度
    if (item.dataset.active === 'true') {
      content.style.height = inner.offsetHeight + 'px';
    } else {
      content.style.height = '0';
    }

    header.addEventListener('click', () => {
      const isActive = item.dataset.active === 'true';

      // 切换状态
      item.dataset.active = (!isActive).toString();

      // 设置内容高度
      content.style.height = !isActive ? inner.offsetHeight + 'px' : '0';
    });
  });
});
